'use client';
import React, { useEffect } from 'react';
import * as Sentry from '@sentry/nextjs';
import SomethingWentWrong from '@/components/shared/SomethingWentWrong';

export default function LobbyErrorPage({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // Log the error to Sentry
    Sentry.captureException(error);
  }, [error]);

  return <SomethingWentWrong onRetry={reset} />;
}
